

export default class CollectionHelpers {

    static lookupValue(collection, propertyName, findValue, returnValue) {   
        let objFound = collection.find(o => o[propertyName] == findValue)
        return objFound[returnValue]
    }
    static getMostRecentItem(collection) {  
        let maxDate = null
        let mostRecent = null 
        collection.forEach(item => {
            const dt = item.created || item.createdAt || item.date
            if(dt > maxDate || maxDate == null) {
                maxDate = dt
                mostRecent = item
            }

        })
        return mostRecent
    }
    static insertOrMoveToTop(item, arr) {
        const idx = arr.findIndex(o => o._id == item._id)
        if(idx > -1)
            arr.splice(idx, 1)
        arr.unshift(item)
    }

    
}


// WEBPACK FOOTER //
// ./src/helpers/CollectionHelpers.js